import React, { useCallback, useRef } from 'react';
import { toCanvas } from 'html-to-image';
import { ResourceModalContent } from './ResourceModalContent';
export const SelectedResourceContent = ({ modalResource, showShare }) => {
    const contentRef = useRef(null);
    const shareEvent = useCallback(() => {
        if (contentRef.current === null)
            return;
        const filename = modalResource.key || 'share-image';
        const shareImages = contentRef.current.querySelectorAll('[data-share-image]');
        if (shareImages.length) {
            shareImages.forEach((node, index) => {
                var _a;
                const filenameSuffix = ((_a = node.dataset) === null || _a === void 0 ? void 0 : _a.shareImage) || index;
                toCanvas(node, { cacheBust: true, canvasWidth: 600, canvasHeight: 600 })
                    .then((canvas) => {
                    // contentRef.current.appendChild( )
                    const link = document.createElement('a');
                    link.download = `${filename}-${filenameSuffix}.png`;
                    link.href = canvas.toDataURL();
                    link.click();
                })
                    .catch((err) => {
                    console.log(err);
                });
            });
        }
        else {
            toCanvas(contentRef.current, { cacheBust: true, canvasWidth: 600, canvasHeight: 600 })
                .then((canvas) => {
                // contentRef.current.appendChild( )
                const link = document.createElement('a');
                // link.download = `${filename}.png`;
                link.href = canvas.toDataURL();
                link.click();
            })
                .catch((err) => {
                console.log(err);
            });
        }
    }, [contentRef]);
    return (React.createElement("div", { tabIndex: 0 },
        React.createElement(ResourceModalContent, { vars: modalResource }),
        showShare && (React.createElement("div", { className: "EventModal__shareButtonContainer" },
            React.createElement("button", { className: 'Button Button--secondary EventModal__shareButton', onClick: shareEvent },
                React.createElement("span", { className: 'EventModal__shareButtonLabel' }, "Share"))))));
};
